import React from "react";
import "./Banner2.css"
import { useSelector } from "react-redux";

function Banner2() {

  const product = useSelector((state) => state.product?.product?.banner2);

  return (
    <section className="banner2">
      <div className="container-fluid p-0">
        <div className="banner_wrapper">
          {/* <img
            src="/assets/images/about-us/about-banner.png"
            alt="banner"
            className="banner_img"
          /> */}
          <img src={process.env.REACT_APP_IMG_URL + product} alt="banner"  className="banner_img" />
        </div>
      </div>
    </section>
  );
}

export default Banner2;
